const state = {
    Items: {
        data: [],
        total: 0,
        pages: {
            page: 1,
            totalPage: 1,
            limit: 25,
            filter: {}
        },
    },
    Loadings: {
        list: false,
        detail: false,
    },
    Item: null,
    Requestors: {},
    FaulTypes: {},
};

const getters = {
    Items: (state) => state.Items,
    Loadings: (state) => state.Loadings,
    Item: (state) => state.Item,
};

const actions = {
    async getList({ commit }, params) {
        commit('setLoadings', { key: "list", val: true });
        return new Promise((resolve, reject) => {
            global.axios.get(`api/old-case`, { params: params })
                .then(response => {
                    commit('setLoadings', { key: "list", val: false });
                    response.data.data.pages = params
                    commit('setListItems', response.data.data);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
   

   

    async getCase({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/old-case/${params.case_id}`)
                .then(response => {
                    response.data.data.pages = params
                    commit('setItem', response.data.data);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
   
   
   
};

const mutations = {
    setListItems(state, data) {
        data.pages.totalPage = Math.ceil(data.total / data.pages.limit)
        state.Items.data = data.items
        state.Items.total = data.total
        state.Items.pages = data.pages
    },
    setTotalListItems(state, total) {
        state.Items.total = total
    },
    setSimilarCase(state, data) {
        data.pages.totalPage = Math.ceil(data.total / data.pages.limit)
        state.Items.data = data.items
        state.Items.total = data.total
        state.Items.pages = data.pages
    },
    setLoadings(state, data) {
        state.Loadings[data.key] = data.val;
    },
    setSelectRequestors(state, data) {
        state.Requestors.data = data.items;
        state.Requestors.total = data.total;
    },
    setFaultTypes(state, data) {
        state.FaulTypes.data = data.items;
        state.FaulTypes.total = data.total;
    },
    setItem(state, data) {
        state.Item = data;
    },
    updateRemarkCase(state, data) {
        state.Item = {...state.Item, ...data };
    },
    deleteAttachments(state, data) {
        if (data.action == 'action_taken') {
            state.Item.action_taken.attachments = state.Item.action_taken.attachments.filter(img => !data.ids.includes(img.id))
        }
        if (data.action == 'work_finding') {
            state.Item.work_finding.attachments = state.Item.work_finding.attachments.filter(img => !data.ids.includes(img.id))
        } else {
            state.Item.attachments = state.Item.attachments.filter(img => !data.ids.includes(img.id))
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}